import React from 'react'
import { Modal, Button } from 'react-bootstrap'

interface Props {
    show: boolean
    onHide: () => void
    paymentScaleInfo: string
}

export const PaymentScaleModal = ({ show, onHide, paymentScaleInfo }: Props) => {


    const formattedPaymentScaleInfo = paymentScaleInfo.replace(/\n/g, '<br>')


    return (
        <Modal show={show} onHide={onHide}>

            <Modal.Header closeButton>
                <Modal.Title>Explicación Escala de Pagos</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='d-flex justify-content-center'>
                    <div dangerouslySetInnerHTML={{ __html: formattedPaymentScaleInfo }} />
                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
